'use strict';

angular.module('cimerFrontEndApp').directive('reportCompositeScore',[function() {
    return {
        restrict: 'EA',
        templateUrl: '/Content/Templates/survey/reportCompositeScoreTemplate.html',
        scope: {
            prompt: '=prompt',
            index: '=index'
        },
        link: function (scope, elements, attrs) {
            scope.prompt.open = false;
        }
    };
}]);
